import { icons, LucideProps } from "lucide-react";
import { PdfIcon } from "@/components/PdfDocument/PdfIcon";
import {
    GLOBAL_STYLE_KEY,
    resumeFontSizes,
    resumeIconSizes,
} from "@/constants/resume";
import { getIsDarkTheme } from "@/store/resume/utils";
import { ResumeStyles } from "@/types/resume";

interface FieldIconProps extends Omit<LucideProps, "ref"> {
    name?: string;
    stylesConfig: ResumeStyles;
    isForPdf?: boolean;
    isStaticHeader: boolean;
}

export const FieldIcon = ({
    name,
    stylesConfig,
    isForPdf,
    isStaticHeader,
}: FieldIconProps) => {
    if (!name) return null;
    const iconsEnabled = stylesConfig[GLOBAL_STYLE_KEY].showIcons;
    const LucideIcon = iconsEnabled ? icons?.[name] : undefined;
    const sizeKey =
        stylesConfig?.[GLOBAL_STYLE_KEY]?.fontSize || resumeFontSizes[0].value;
    const size = resumeIconSizes[sizeKey];
    const isDarkTheme = isStaticHeader
        ? getIsDarkTheme(stylesConfig?.[GLOBAL_STYLE_KEY]?.themeColor)
        : false;

    if (!LucideIcon) return null;

    return isForPdf ? (
        <PdfIcon
            name={name}
            size={size}
            isDarkTheme={isDarkTheme}
        />
    ) : (
        <LucideIcon
            size={size}
            className="mr-1 mt-[2px] flex-shrink-0"
            height={size}
            width={size}
            color={isDarkTheme ? "#fff" : "#000"}
        />
    );
};
